export type MFAMethod = 'email' | 'sms';

export interface MFAMethodOption {
  method: MFAMethod;
  destination: string;
}

export interface AuthenticatedLogin {
  userSlug: string;
  userType: string;
  rules: Rules;
  message?: string;
  mfa?: never;
}

export interface ChooseMFAMethodResponse {
  mfa: { state: 'choose_method'; methods: MFAMethodOption[] };
  message?: string;
}

export interface MFACodeSentResponse {
  mfa: { state: 'code_sent' } & MFAMethodOption;
  message?: string;
}

export interface LegacyMFAResponse {
  message: 'Provide OTP code.';
  mfa?: never;
}

export type MFAResponse = ChooseMFAMethodResponse | MFACodeSentResponse | LegacyMFAResponse;
export type LoginResponse = AuthenticatedLogin | MFAResponse;
export type MFASendResponse = MFACodeSentResponse | { message: string; mfa?: never };

export interface AuthErrorData {
  location?: string;
  errors?: string[];
  userMessages?: string[];
}

export function isMFAResponse(data: unknown): data is MFAResponse {
  if (!data || typeof data !== 'object') {
    return false;
  }

  return ('mfa' in data && data.mfa !== undefined) || ('message' in data && data.message === 'Provide OTP code.');
}

export function isAuthenticatedLogin(data: unknown): data is AuthenticatedLogin {
  return (
    !!data &&
    typeof data === 'object' &&
    !isMFAResponse(data) &&
    'userSlug' in data &&
    typeof data.userSlug === 'string' &&
    'userType' in data &&
    typeof data.userType === 'string' &&
    'rules' in data &&
    Array.isArray(data.rules)
  );
}

export type HandleLogin = (
  data: { email: string; password: string },
  resetField: (name: 'email' | 'password') => void
) => void;
